module.exports = __webpack_public_path__ + "img/environment_indoor3.7cfecc2b.jpg";